module.exports = __webpack_public_path__ + "static/media/32-web-or-mls-DSC06780.fd35acc2.jpg";